<template>
  <section
    aria-label="Video player"
    class="w-full"
  >
    <div class="rv-video__outer">
      <youtube
        ref="youtube"
        :video-id="youTubeId(video.src)"
        :player-vars="playerVars"
        :width="'100%'"
        :height="'100%'"
        class="rv-video__inner"
        @playing="handlePlay"
        @ended="handleStop"
        @paused="handleStop"
      />
    </div>

    <ul
      v-if="post.youtube_transcribed || post.yotube_described"
      class="lg:flex lg:justify-between mb-2"
    >
      <li v-if="post.youtube_transcribed">
        <button
          aria-controls="video-transcription"
          data-gtm-transcription="transcription"
          :aria-expanded="transcription"
          class="ml-5vw lg:ml-0 mt-2 focus-a text-white underline font-graphiklight"
          @click="transcription = !transcription"
        >
          {{ transcription ? 'Hide transcription': 'Show transcription'}}
        </button>
      </li>
      <li v-if="post.youtube_described">
        <button
          class="ml-5vw lg:ml-0 mt-2 focus-a text-white underline font-graphiklight"
          @click="$store.commit('toggleAudioDescription')"
        >
          {{ video.text }}
        </button>
      </li>
    </ul>

    <Expand v-show="transcription">
      <div
        id="video-transcription"
        class="h-64 lg:h-32 mx-5vw lg:mx-0 p-4 bg-black overflow-auto"
        v-html="post.youtube_transcribed"
      />
    </Expand>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import Expand from '@/components/utility/Expand.vue'

export default {
  name: 'Video',

  components: {
    Expand
  },

  props: {
    post: {
      type: Object,
      default: () => {}
    }
  },

  data: () => ({
    playerVars: {
      rel: 0,
      modestbranding: 1,
      origin: window.location.hostname
    },
    transcription: false
  }),

  computed: {
    ...mapState([ 'isAudioDescribed' ]),

    player() {
      return this.$refs.youtube.player
    },
    video() {
      const src = this.post.youtube_described && this.isAudioDescribed ? this.post.youtube_described : this.post.youtube
      const text = this.post.youtube_described && this.isAudioDescribed ? 'Watch non audio described version' : this.post.youtube_described ? 'Watch audio described version' : ''

      return {
        src: src,
        text: text
      }
    }
  },

  methods: {
    playVideo() {
      this.player.playVideo()
    },
    stopVideo() {
      this.player.stopVideo()
    },
    handlePlay() {
      // This.$store.commit('toggleVideo', true)
    },
    handleStop() {
      // This.$store.commit('toggleVideo', false)
    },
    youTubeId(inputUrl) {
      const outputUrl = inputUrl.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/)
      return undefined !== outputUrl[2] ? outputUrl[2].split(/[^0-9a-z_\-]/i)[0] : outputUrl[0]
    }
  }
}
</script>

<style>
.rv-video__outer {
  height: 0;
  padding-top: 56.25%;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.rv-video__inner {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
</style>
